import { FC, ReactElement } from 'react';
import styled from 'styled-components';

const Header = styled.div`
  height: 100px;
  width: 100%;
  background-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
`;

const Logo = styled.img`
  height: 90px;
  padding: 25px 10px 10px;
  filter: brightness(1.2) contrast(1.1);
`;

const HeaderComp: FC = (): ReactElement => (
  <Header>
    <Logo src='/logo.webp' />
  </Header>
);

export default HeaderComp;
